import {EventEmitter, Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {PassengerUpdate} from '../models/passenger.model';
import {Discount} from '../models/discount.model';

@Injectable({providedIn: 'root'})
export class EditingService {

    passengers: PassengerUpdate[] = [];

    adult_num = 0;
    child_num = 0;
    infant_num = 0;

    dep_adult_price = 0;
    dep_child_price = 0;
    dep_infant_price = 0;
    re_adult_price = 0;
    re_child_price = 0;
    re_infant_price = 0;

    setPassengersEmitter = new EventEmitter<number>();
    setTicketsEmitter = new EventEmitter<number>();

    ticketDep: any = null;
    ticketRe: any = null;

    is_valid_ticket: boolean;
    isValidTicketChanged = new Subject<boolean>();

    pnrChanged = new Subject<string>();

    private discounts: Discount[];
    private discountInUse: Discount;
    discountInUseSub = new Subject<Discount>();

    invoiceAmount = 0;
    invoiceAmountChanged = new Subject<number>();

    isDividedPassengers: PassengerUpdate[] = [];

    log_txt_sub = new EventEmitter<string>();

    error_message_sub = new EventEmitter<string>();


    setTicketRe(ticket: any) {
        this.ticketRe = ticket;
    }

    setIsValidTicket(isValid) {
        this.is_valid_ticket = isValid;
        this.isValidTicketChanged.next(isValid);
    }

    getIsValidTicket() {
        return this.is_valid_ticket;
    }


    // *** Discount *** //

    setDiscount(discounts: Discount[]) {
        this.discounts = discounts;
    }

    // have to add calculate discount amount and show
    checkIsValidDiscountCode(code: string, date: string) {
        const discount_code_obj: Discount = this.discounts.filter(f => f.code === code)[0];
        // check if discount code exist
        if (!discount_code_obj) {
            return false;
        }
        // check if expired
        if (!(discount_code_obj.start <= date && discount_code_obj.end >= date)) {
            return false;
        }
        this.setDiscountInUse(discount_code_obj);
        return true;
    }

    getDiscountAmountById(discount_id: number) {
        for (const discount of this.discounts) {
            if (discount.id === discount_id) {
                return discount.amount;
            }
        }
    }

    setDiscountInUse(discount: Discount) {
        this.discountInUse = discount;
        this.discountInUseSub.next(discount);
    }

    setDiscountInUseById(discount_id: number) {
        this.discountInUse = this.discounts.filter(item => item.id === discount_id)[0];
        this.discountInUseSub.next(this.discountInUse);
    }

    getDiscountInUse() {
        return this.discountInUse;
    }

    resetDiscount() {
        this.discountInUse = null;
        this.discountInUseSub.next(null);
    }


    // *** Passenger Number *** //

    plus_adult_num(adult_num: number) {
        this.adult_num = this.adult_num + adult_num;
    }

    minus_adult_num(adult_num: number) {
        this.adult_num = this.adult_num - adult_num;
    }

    plus_child_num(child_num: number) {
        this.child_num = this.child_num + child_num;
    }

    minus_child_num(child_num: number) {
        this.child_num = this.child_num - child_num;
    }
    plus_infant_num(infant_num: number) {
        this.infant_num = this.infant_num + infant_num;
    }
    minus_infant_num(infant_num: number) {
        this.infant_num = this.infant_num - infant_num;
    }

    getTotalNum() {
        return this.adult_num + this.child_num;
    }


    // *** Price *** //

    setPrice(dep_adult_price: number, dep_child_price: number,  dep_infant_price: number
        , re_adult_price: number, re_child_price: number, re_infant_price: number) {
        this.dep_adult_price = dep_adult_price;
        this.dep_child_price = dep_child_price;
        this.dep_infant_price = dep_infant_price;
        this.re_adult_price = re_adult_price;
        this.re_child_price = re_child_price;
        this.re_infant_price = re_infant_price;
        this.setInvoice();
    }

    setInvoice() {
        const dep_adult_price = this.dep_adult_price;
        const dep_child_price = this.dep_child_price;
        const dep_infant_price = this.dep_infant_price;
        const re_adult_price = this.re_adult_price !== 0 ? this.re_adult_price : null;
        const re_child_price = this.re_child_price !== 0 ? this.re_child_price : null;
        const re_infant_price = this.re_infant_price !== 0 ? this.re_infant_price : null;
        if (this.discountInUse) {
            // promo_code discount
            this.invoiceAmount = ((dep_adult_price - +this.discountInUse.amount) * this.adult_num)
                + ((dep_child_price - +this.discountInUse.amount) * this.child_num)
                + ((dep_infant_price - +this.discountInUse.amount) * this.infant_num)
                + ((re_adult_price ? re_adult_price - +this.discountInUse.amount : 0) * this.adult_num)
                + ((re_child_price ? re_child_price - +this.discountInUse.amount : 0) * this.child_num)
                + ((re_infant_price ? re_infant_price - +this.discountInUse.amount : 0) * this.infant_num);
        } else {
            // valid_ticket discount
            /*          if (this.is_valid_ticket) {
                          this.invoiceAmount = 0;
                      } else {*/
            this.invoiceAmount = (dep_adult_price * this.adult_num)
                + (dep_child_price * this.child_num)
                + (dep_infant_price * this.infant_num)
                + (re_adult_price ? re_adult_price * this.adult_num : 0)
                + (re_child_price ? re_child_price * this.child_num : 0)
                + (re_infant_price ? re_infant_price * this.infant_num : 0);
        }
        this.invoiceAmountChanged.next(this.invoiceAmount);
    }

    resetInvoice() {
        this.invoiceAmount = 0;
        this.invoiceAmountChanged.next(this.invoiceAmount);
    }

    getInvoice() {
        return this.invoiceAmount;
    }


    // *** Divide Reservation *** //

    addIsDividePassengers(passenger: PassengerUpdate) {
        this.isDividedPassengers.push(passenger);
    }

    removeIsDividePassengers(passenger: PassengerUpdate) {
        this.isDividedPassengers = this.isDividedPassengers.filter(item => item !== passenger);
    }

    getIsDividePassengers() {
        return this.isDividedPassengers;
    }

    reset() {
        this.adult_num = 0;
        this.child_num = 0;
        this.infant_num = 0;
        this.passengers = [];
        this.ticketDep = null;
        this.ticketRe = null;
    }

}
